// extracted by mini-css-extract-plugin
export default {"zoomModal":"D2-z"};